module.exports = __webpack_public_path__ + "img/maskOverlay.e0ec4d1d.png";